import {useQuery} from "@tanstack/react-query"
import {calendarIntegrationService} from "services"
import {IntegrationAccount} from "types/calendar"

export const MY_INTEGRATION_ACCOUNTS_QUERY_KEY = ["my-integration-accounts"]

const EMPTY_ACCOUNTS: IntegrationAccount[] = []

/**
 * Linked Google/Outlook accounts with every calendar the provider returns for them.
 * Errors are not surfaced: the sidebar falls back to the calendars Edular already has.
 */
export const useMyIntegrationAccounts = (options?: {enabled?: boolean}) => {
    const query = useQuery(MY_INTEGRATION_ACCOUNTS_QUERY_KEY, () => calendarIntegrationService.getMyAccounts(), {
        enabled: options?.enabled ?? true,
        staleTime: 5 * 60 * 1000,
        retry: 1
    })

    return {
        accounts: query.data ?? EMPTY_ACCOUNTS,
        isLoaded: query.isSuccess,
        isLoading: query.isLoading,
        refetch: query.refetch
    }
}
